<template>
  <v-row dense>
    <v-col cols="4">
      <v-text-field
        v-model="form.abacus_id"
        :rules="rules.abacusNumber"
        :label="`${$t('EMPLOYEES.ABACUS_NUMBER')}`"
        :readonly="readonly"
        :error-messages="errors.abacus_id"
        @input="updateValue('abacus_id', $event)"
      />
    </v-col>
    <v-col col="4">
      <v-text-field
        v-model="form.per_address"
        :rules="rules.per_address"
        :counter="100"
        :readonly="readonly"
        :label="`${$t('COMPANIES.PER_ADDRESS')}`"
        :error-messages="errors.per_address"
        @input="updateValue('per_address', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import {
  maxLength,
  positiveNumber,
  isInteger,
  lengthNumber
} from '@/modules/_global/variables/rules';

export default {
  name: 'EreporterForm',

  mixins: [formEditable],

  data() {
    return {
      form: {
        per_address: '',
        abacusNumber: ''
      }
    };
  },

  computed: {
    rules() {
      return {
        per_address: [maxLength(100)],
        abacusNumber:
          this.form.abacus_id !== ''
            ? [positiveNumber, isInteger, lengthNumber(5)]
            : []
      };
    }
  }
};
</script>
